import React from 'react';

import { useSearchResults } from '@context/DataContext';
import PaginationControl from '@atoms/Pagination/PaginationControl';
import PaginationItem from '@atoms/Pagination/PaginationItem';

const Pagination = ({ itemType = 'link', label = 'Pagination', stepLabel = 'page', disabled = false }) => {
  if (disabled) return null;

  const { pagination, resultTab } = useSearchResults();
  const { controls, items } = pagination;
  const maybeControlPrevious = controls?.previous ? (
    <PaginationControl direction="previous" itemType={controls.previous.itemType || itemType} stepLabel={controls.previous.stepLabel || stepLabel} />
  ) : null;
  const maybeControlNext = controls?.next ? (
    <PaginationControl direction="next" itemType={controls.next.itemType || itemType} stepLabel={controls.next.stepLabel || stepLabel} />
  ) : null;

  const maybePagination =
    items.length && resultTab !== 'saved' ? (
      <nav className="base-search-pagination__wrapper" aria-label={label}>
        <ul className="base-search-pagination-list">
          {maybeControlPrevious}
          {items.map((item) => {
            const { itemType: paginationItemType, pageNumber: paginationItemPageNumber, stepLabel: paginationItemStepLabel } = item;
            const itemProps = {
              ...item,
              itemType: paginationItemType ? paginationItemType : itemType,
              stepLabel: paginationItemStepLabel ? paginationItemStepLabel : stepLabel,
            };
            return <PaginationItem {...itemProps} key={`pagination-item-${paginationItemPageNumber}`} />;
          })}
          {maybeControlNext}
        </ul>
      </nav>
    ) : null;

  return maybePagination;
};

export default Pagination;
